import { styled } from '@mui/material'
import { Divider } from 'presentation/components/atoms/divider'

export const StyledDivider = styled(Divider)(({ theme }) => ({
  height: 18,
  width: 2,
  background: theme.palette.common.white,
  opacity: 0.4,
}))
